// extracted by mini-css-extract-plugin
module.exports = {"arrowMoreComponent":"load-more_arrowMoreComponent__gYgKg","loader":"load-more_loader__RJKDh"};